import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { PartnersListState, PARTNERS_LIST_SLICE_NAME } from './models';

export const partnersListSelector = (state: RootState): PartnersListState => state[PARTNERS_LIST_SLICE_NAME];

export const selectUsersIsLoading = createSelector(partnersListSelector, (state: PartnersListState) => state.isLoading);

export const selectPartnersList = createSelector(
  partnersListSelector,
  (state: PartnersListState) => state.partnersList,
);

export const selectQuery = createSelector(partnersListSelector, (state: PartnersListState) => state.query);
